import { ProjectsStateCurrentProject } from '@he-novation/config/types/project.types';
import { atom } from 'jotai';

import { FilterName, FilterValueId } from '$components/Filters/FilterCheckboxes';
import {
    CalendarFilterEnum,
    CalendarItemColorType,
    CalendarZoom,
    GlobalRowsType,
    ScrollCalendarGrouper,
    ScrollCalendarItemType
} from '$components/ScrollCalendar/ScrollCalendar.types';

export const calendarZoomAtom = atom<CalendarZoom>(CalendarZoom.Weeks);
export const calendarGrouperAtom = atom<ScrollCalendarGrouper>(ScrollCalendarGrouper.Users);
export const calendarActiveFiltersAtom = atom<Record<FilterName, FilterValueId[]>>({
    [CalendarFilterEnum.Teams]: [],
    [CalendarFilterEnum.Labels]: [],
    [CalendarFilterEnum.Authors]: []
});
export const calendarActiveGrouperFilters = atom<string[]>([]);
export const calendarItemsAtom = atom<ScrollCalendarItemType[]>([]);
export const calendarItemColorTypeAtom = atom<CalendarItemColorType>(CalendarItemColorType.Label);
export const calendarDateRangeAtom = atom<Date[]>([new Date(), new Date()]);
export const calendarProjectAtom = atom<ProjectsStateCurrentProject | undefined>(undefined);
export const calendarGlobalRowsAtom = atom<GlobalRowsType | undefined>(undefined);
export const calendarActiveCenteredDateAtom = atom<Date>(new Date());
